import React from 'react';
import PropTypes from 'prop-types';

export default class ModalUserConfirm extends React.Component {
    static propTypes = {
        reasonCantDelete: PropTypes.string,
        projectUser: PropTypes.object,

        onCancel: PropTypes.func,
    }

    render() {
        const user = gd.session.users.get(this.props.projectUser.userId);

        return (
            <React.Fragment>
                <div className="iv-header header-left header-small-no-separator">
                    <div className="title-line">
                        <div className="view-name">
                            <div className="view-name ui5-title-app-name">
                                <div className="gd-btn-arrow-left-blue-22 m-r-10" onClick={this.props.onCancel}/>
                                {user.name}
                            </div>
                        </div>
                    </div>
                </div>

                <div className="iv-content with-left-panel">
                    <div className="ui5-info-panel big-panel m-l-10 m-r-10">
                        <div className="ip-section">
                            <div className="ui5-txt-less-important m-b-30">
                                {this.props.reasonCantDelete}
                            </div>
                        </div>
                    </div>
                </div>
            </React.Fragment>
        );
    }
}